import axios from "axios";

export const apiOSS = axios.create();

export function setBaseUrl(baseUrl: string) {
  apiOSS.defaults.baseURL = baseUrl;
}

export default apiOSS;
